import Component from '../Component';

class Modal extends Component {
  constructor(options) {
    super(options);
    this.close = this.root.querySelector('.close_btn');
  }

  openModal() {
    if (this.root.classList.contains('closed')) {
      this.root.classList.add('fade-in');

      this.root.addEventListener('animationend', () => {
        this.root.classList.remove('fade-in', 'closed');
        this.root.classList.add('open');
      });
    }
  }

  closeModal() {
    if (this.root.classList.contains('open')) {
      this.root.classList.add('fade-out');

      this.root.addEventListener('animationend', () => {
        this.root.classList.remove('fade-out', 'open');
        this.root.classList.add('closed');
      });
    }
  }

  attachEventListeners() {
    const modalLink = document.querySelectorAll('a[href="#modal"]');
    const bannerModal = document.querySelector('.banner a[href="#modal"]');
    const resaleModal = document.querySelector('.resale');

    modalLink.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const { target } = e;

        if (target === resaleModal) {
          if (this.root.classList.contains('banner_modal')) {
            this.root.classList.remove('banner_modal');
          }
          this.root.classList.add('resale_modal');
        }

        if (target === bannerModal) {
          if (this.root.classList.contains('resale_modal')) {
            this.root.classList.remove('resale_modal');
          }
          this.root.classList.add('banner_modal');
        }

        this.openModal();
      });
    });

    this.close.addEventListener('click', () => {
      this.closeModal();
    });

    window.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default Modal;
